import { PlanogramContainer } from "./PlanogramContainer.js";
import { PlanogramRenderer } from "./PlanogramRenderer.js";
export class PlanogramToolBar extends HTMLElement {
    /** @type {PlanogramContainer} */
    #parentContainer = null;
    constructor() {
        super();
        this.attachShadow({ mode: 'open' });
    }
    connectedCallback() {
        const slot = document.createElement('slot');
        this.shadowRoot.appendChild(slot);
        this.slot = "toolbar";
        if(this.parentElement instanceof PlanogramContainer){
            this.#parentContainer = this.parentElement;
            // Query cameras by container-id since cameras are no longer children of the container
            const renderer = PlanogramRenderer.get(this.#parentContainer);
            if (renderer && this.#parentContainer.containerId) {
                [...renderer.querySelectorAll(`planogram-camera[container-id='${this.#parentContainer.containerId}']`)].forEach(camera=>{
                    camera.cameraFrame?.createToolBar();
                });
            }
        }
    }
    disconnectedCallback(){
        if(this.#parentContainer){
            // Query cameras by container-id since cameras are no longer children of the container
            const renderer = PlanogramRenderer.get(this.#parentContainer);
            if (renderer && this.#parentContainer.containerId) {
                [...renderer.querySelectorAll(`planogram-camera[container-id='${this.#parentContainer.containerId}']`)].forEach(camera=>{
                    camera.cameraFrame?.createToolBar();
                });
            }
            this.#parentContainer = null;
        }
    }
}